'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const clamp = require('../../../../../popmotion/dist/es/utils/clamp.js');
require('../../../../../popmotion/dist/es/animations/generators/spring.js');
const progress = require('../../../../../popmotion/dist/es/utils/progress.js');
const mix = require('../../../../../popmotion/dist/es/utils/mix.js');
require('../../../../../popmotion/dist/es/utils/mix-color.js');
require('../../../../../popmotion/dist/es/utils/pipe.js');
require('../../../../../popmotion/dist/es/utils/mix-complex.js');
require('../../../../../popmotion/dist/es/utils/interpolate.js');
require('../../../../../popmotion/dist/es/easing/utils.js');
require('../../../../../popmotion/dist/es/easing/index.js');
require('../../../../../popmotion/dist/es/animations/generators/keyframes.js');
require('../../../../../popmotion/dist/es/animations/generators/decay.js');
require('../../../../../popmotion/dist/es/animations/index.js');
require('../../../../../popmotion/dist/es/utils/velocity-per-second.js');
require('../../../../../popmotion/dist/es/animations/inertia.js');
require('../../../../../popmotion/dist/es/utils/is-point.js');
require('../../../../../popmotion/dist/es/utils/is-point-3d.js');
const distance = require('../../../../../popmotion/dist/es/utils/distance.js');
require('../../../../../popmotion/dist/es/easing/cubic-bezier.js');

var clampProgress = function (v) {
  return clamp.clamp(0, 1, v);
};
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */
function isNear(value, target, maxDistance) {
  if (target === void 0) {
    target = 0;
  }
  if (maxDistance === void 0) {
    maxDistance = 0.01;
  }
  return distance.distance(value, target) < maxDistance;
}
function calcLength(axis) {
  return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
  var origin = 0.5;
  var sourceLength = calcLength(source);
  var targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress.progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress.progress(source.min, source.max - targetLength, target.min);
  }
  return clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateAxisDelta(delta, source, target, origin) {
  if (origin === void 0) {
    origin = 0.5;
  }
  delta.origin = origin;
  delta.originPoint = mix.mix(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  if (isNear(delta.scale, 1, 0.0001)) delta.scale = 1;
  delta.translate = mix.mix(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate)) delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateBoxDelta(delta, source, target, origin) {
  updateAxisDelta(delta.x, source.x, target.x, defaultOrigin(origin.originX));
  updateAxisDelta(delta.y, source.y, target.y, defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */
function defaultOrigin(origin) {
  return typeof origin === "number" ? origin : 0.5;
}

exports.calcOrigin = calcOrigin;
exports.isNear = isNear;
exports.updateAxisDelta = updateAxisDelta;
exports.updateBoxDelta = updateBoxDelta;
